import App from './App.svelte';

const app = new App({
	target: document.getElementById("zokeprofiel-form-container"),
	props: {}
});

export default app;